import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

// AWS
import { API, Auth } from "aws-amplify";

let promiseGlobal = null;

function useGetLoanCount({ setCountObj, ...query }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    getData(query);
  }, []);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const getData = async (where) => {
    try {
      setLoading(true);
      let datas = {};
      let count = 0;
      let lastItem = null;
      let allItems = [];

      // To cancel the above request
      if (promiseGlobal) {
        API.cancel(promiseGlobal, "my message for cancellation");
      }

      do {
        const promise = API.get("MoneyHubAdmin", "/loan/count", {
          queryStringParameters: {
            ...where,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        promiseGlobal = promise;
        const datas = await promise;
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        allItems = [...allItems, ...datas?.body?.loan];
        // setDatas(count);
        setCountObj((prev) => {
          return {
            ...prev,
            [where.status]: count,
          };
        });
      } while (lastItem);

      // setDatas(count);
      setItems((prev) => {
        return [...prev, ...allItems].map((item) => {
          return {
            ...item,
            job_no: item?.loan_kbank_id,
          };
        });
      });
    } catch (error) {
      setError(true);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
    setCheckSubmit,
    getLastItem,
    items,
  };
}

export default useGetLoanCount;
